module.exports = __webpack_public_path__ + "img/osm.1b7f66e1.png";